import { type LucideIcon } from 'lucide-react-native';
import { useCSSVariable } from 'uniwind';

export interface IconProps {
  /** A Lucide icon component, e.g. `Settings`. */
  icon: LucideIcon;
  /** Pixel size of the (square) icon. */
  size?: number;
  /** Theme color token to resolve for the stroke, e.g. `--color-foreground`. */
  colorVar?: string;
  strokeWidth?: number;
}

/** Renders a Lucide icon colored from a theme token so it tracks light/dark. */
export function Icon({
  icon: LucideComponent,
  size = 22,
  colorVar = '--color-foreground-secondary',
  strokeWidth = 2,
}: IconProps) {
  const resolved = useCSSVariable(colorVar);
  const color = typeof resolved === 'string' ? resolved : undefined;
  return <LucideComponent size={size} color={color} strokeWidth={strokeWidth} />;
}
